import "../assets/less/main.less";
import  "yet-another-react-lightbox/styles.css";
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';

// React 18-compatible rendering
const container = document.getElementById('mscpastapp');
const root = createRoot(container);
root.render(<App />);
